/**
 * THIS MODULE REQUIRES ARGA_wrapper.js globals:
 *
 * Functions:
 * ---------
 * Get_ARGA_LearnerResponse
 * Get_ARGA_LearnerResponse_Class
 * Get_ARGA_Data
 * Get_ARGA_Grade
 * Get_ARGA_Data_Class
 *
 * Set_ARGA_Question_Response
 * Set_ARGA_Completion_Status (ARGA_wrapper v4 only)
 * Save_ARGA_Data
 *
 * Callbacks:
 * ---------
 * Save_ARGA_Data_Callback
 */

'use strict';

import _ from 'lodash'
import moment from 'moment'


/**
 *
 * @param lc LegacyEngineModels.LearningCurve
 */
export function storeArgaData(lc, dueDateHasPassed) {
    // return if arga wasn't initialized or if the due date has passed -- no data would be stored
    // in the latter case
    if (dueDateHasPassed === 1 || Get_ARGA_Data("due_date_has_passed")) {
        return;
    }

    // questions received, next question level, and points earned and available for each topic
    for (var i = 0; i < lc.allTopics.length; ++i) {
        var t = lc.allTopics[i];

        var stub = "t" + i;
        Set_ARGA_Data(stub + "_qa", t.questionsReceived);
        Set_ARGA_Data(stub + "_nl", t.nextLevel);
        Set_ARGA_Data(stub + "_pa", t.totalPointsAvailable);
        Set_ARGA_Data(stub + "_pe", t.totalPointsEarned);
    }

    // current activity score
    Set_ARGA_Question_Response({
        questionNum:'1',
        questionType:'',
        questionText:'Current activity score',
        correctAnswer:'',
        learnerResponse:lc.score.activityScore,
        questionGrade:-1,
        questionWeight:-1,
        questionData:''
    });

    // questions answered
    Set_ARGA_Question_Response({
        questionNum:'2',
        questionType:'',
        questionText:'Total questions received',
        correctAnswer:'',
        learnerResponse:lc.studentData.activity_questions_received,
        questionGrade:-1,
        questionWeight:-1,
        questionData:''
    });

    ARGA_Set_Grade(lc);

    ARGA_Save(lc);
}


// In PX standalone LC, activity_grade can be only 0 or 100.
// We use 0 when students have started the activity and 100 when the students have completed the activity
function ARGA_Set_Grade(lc) {
    Set_ARGA_Grade(lc.score.activityGrade);
    if (lc.score.activityGrade === 0){
        Set_ARGA_Completion_Status('incomplete');
    } else if(lc.score.activityGrade === 100){
        Set_ARGA_Completion_Status('completed');
    }
}

/**
 * @param lc
 *
 * @callback Save_ARGA_Data_Callback
 */
function ARGA_Save(lc) {
    Save_ARGA_Data({show_progress: lc.score.activityGrade === 100});
}


export function restoreArgaData(lc) {

    lc.studentData.user_rights = Get_ARGA_Data("user_rights");
    lc.studentData.user_id = Get_ARGA_Data("learner_id");

    // activity score is stored in question 1.
    lc.score.activityScore = Get_ARGA_LearnerResponse("1");
    if (lc.score.activityScore == "") {
        lc.score.activityScore = 0;
    }
    else {
        lc.score.activityScore *= 1;
    }

    // activity grade, which *should* be 0 or 100 (unless the instructor changed it somehow)
    lc.score.activityGrade = Get_ARGA_Grade();
    if (lc.score.activityGrade < 0) {
        lc.score.activityGrade = 0;
    }

    // due date info
    lc.studentData.user_due_date = Get_ARGA_Data("user_due_date"); // this will be "" if there's no due date

    //PX-6047 Due date time should not be on a 24-hour clock - should be 11:59 pm not, 23:59
    if (lc.studentData.user_due_date) {
        var user_due_date_parts = lc.studentData.user_due_date.match(/(.* at )(\d+)(:\d+)(.*)/);
        if (user_due_date_parts.length === 5 && user_due_date_parts[2] > 12 ){
            user_due_date_parts[2] -= 12;
            lc.studentData.user_due_date = user_due_date_parts[1] + user_due_date_parts[2] + user_due_date_parts[3] + user_due_date_parts[4];
        }
    }

    lc.studentData.due_date_has_passed = Get_ARGA_Data("due_date_has_passed"); // this will be 0 or 1

    calculateClassPerformace(lc);

    lc.studentData.activity_questions_received = Get_ARGA_LearnerResponse("2")

    return lc;
}

// set activity grade in accordance with new score_target if necessary
function ARGA_Check_Grade(lc) {
    if (lc.score.activityGrade === 0 && lc.score.activityScore > lc.score.scoreTarget) {
        lc.score.activityGrade = 100;
        ARGA_Set_Grade(lc);
        ARGA_Save(lc);
    }
    else if (lc.score.activityGrade === 100 && lc.score.activityScore < lc.score.scoreTarget) {
        lc.score.activityGrade = 0;
        ARGA_Set_Grade(lc);
        ARGA_Save(lc);
    }
}

function calculateClassPerformace(lc) {

    var arga = lc.studentData;

    if (arga.user_rights == "3_instructor") {
        arga.user_id_array = Get_ARGA_Data_Class("learner_id");
        arga.user_name_array = Get_ARGA_Data_Class("learner_name");
        arga.user_email_array = Get_ARGA_Data_Class("learner_email");
        arga.user_rights_array = Get_ARGA_Data_Class("user_rights");
        arga.user_due_date_array = Get_ARGA_Data_Class("user_due_date");
        arga.user_due_date_has_passed_array = Get_ARGA_Data_Class("due_date_has_passed");
        arga.user_grade_array = Get_ARGA_Grade_Class();
        arga.user_activity_scores = Get_ARGA_LearnerResponse_Class("1");
        arga.user_questions_received = Get_ARGA_LearnerResponse_Class("2");

        // calculate class averages for questions received and activity scores
        // but only for students! (also count how many students have completed)
        arga.participating_students = 0;
        arga.started_students = 0;
        arga.completed_students = 0;
        var total_student_activity_scores = 0;
        var total_student_questions_received = 0;
        for (var i = 0; i < arga.user_rights_array.length; ++i) {
            if (arga.user_rights_array[i] == '1_student') {
                ++arga.participating_students;
                if (arga.user_activity_scores[i] * 1 > 0) {
                    total_student_activity_scores += arga.user_activity_scores[i] * 1;
                    // student must have scored more than 0 points to be considered started
                    ++arga.started_students;
                }
                if (arga.user_questions_received[i] * 1 > 0) {
                    total_student_questions_received += arga.user_questions_received[i] * 1;
                }
                if (arga.user_grade_array[i] > 0) {
                    ++arga.completed_students;
                }
            }
        }

        if (arga.participating_students > 0) {
            arga.avg_activity_score = Math.round(total_student_activity_scores / arga.participating_students * 10) / 10;
            arga.avg_questions_received = Math.round(total_student_questions_received / arga.participating_students * 10) / 10;
        } else {
            arga.avg_activity_score = 0;
            arga.avg_questions_received = 0;
        }
    }

    // restore data for each topic; along the way figure out which topic has been covered most often
    var max_questions_received = 0;
    for (var i = 0; i < lc.allTopics.length; ++i) {
        var t = lc.allTopics[i];

        var stub = "t" + i;
        t.questionsReceived = argaOrDefault(stub + "_qa", 0);
        t.nextLevel = argaOrDefault(stub + "_nl", 1);
        t.totalPointsAvailable = argaOrDefault(stub + "_pa", 0);
        t.totalPointsEarned = argaOrDefault(stub + "_pe", 0);

        if (t.questionsReceived >= max_questions_received) {
            max_questions_received = t.questionsReceived;
        }

        // console.log("TOPIC " + i + ": " + t.label);
        // console.log(" Questions answered: " + t.questionsReceived);
        // console.log(" Next question level: " + t.nextLevel);
        // console.log(" Points available: " + t.totalPointsAvailable);
        // console.log(" Points earned: " + t.totalPointsEarned);

        // class data for instructors
        if (arga.user_rights == "3_instructor") {
            // questions received (plus participating students)
            var arr = Get_ARGA_Data_Class(stub + "_qa");

            t.class_questions_received = 0;
            t.class_points_available = 0;
            t.class_points_earned = 0;

            var participating_students_this_topic = 0;
            for (var j = 0; j < arr.length; ++j) {
                // skip non-students
                if (arga.user_rights_array[j] > "1_student") {
                    continue;
                }
                ++participating_students_this_topic;
                var val = arr[j] * 1;
                if (!isNaN(val)) {
                    t.class_questions_received += val;
                }
            }

            // class topic score -- we want to average the scores for each student,
            // rather than totaling points available and points earned separately
            t.pa_arr = Get_ARGA_Data_Class(stub + "_pa");
            t.pe_arr = Get_ARGA_Data_Class(stub + "_pe");

            var sum_scores = 0;
            for (var j = 0; j < t.pa_arr.length; ++j) {
                // skip non-students
                if (arga.user_rights_array[j] > "1_student"
                || (arga.user_rights_array[j] === "1_student" && arga.user_grade_array[j] === 0)) {
                    continue;
                }
                var pa = t.pa_arr[j] * 1;
                if (!isNaN(pa) && pa > 0) {
                    sum_scores += (t.pe_arr[j] / pa * 100);
                }

                t.class_points_available += t.pa_arr[j] * 1;
                t.class_points_earned += t.pe_arr[j] * 1;
            }
            t.class_topic_score = 0;
            if (participating_students_this_topic > 0) {
                t.class_topic_score = Math.round(sum_scores / participating_students_this_topic);
            }

        }
    }

    // if any data was retrieved, then the user has started the activity
    if (max_questions_received > 0) {
        arga.activity_started = true;
    }

}

function argaOrDefault(id, default_value) {
    var arga_value = Get_ARGA_Data(id);
    if (arga_value != "") {
        return arga_value * 1;
    }
    else {
        return default_value * 1;
    }
}

export function finishInitialization(lc) {
    lc.students = formatArgaStudents(lc.studentData)

    // check grade now, because score_target might have changed since the last time the user was here
    ARGA_Check_Grade(lc);
}

function simulateData(lc) {
    var arga  = lc.studentData;
    arga.user_rights == '3_instructor';
    arga.user_id_array = ["mcurie@courses.bfwpub.com", "remerson@courses.bfwpub.com", "alovelace@courses.bfwpub.com", "lpasteur@courses.bfwpub.com", "asmith@courses.bfwpub.com"];
    arga.user_firstName_array = ["Marie", "Ralph", "Ada", "Louis", "Adam"];
    arga.user_lastName_array = ["Curie", "Emerson", "Lovelace", "Pasteur", "Smith"];
    arga.user_rights_array = ["1_student", "1_student", "1_student", "1_student", "1_student"];
    arga.user_due_date_array = ["", "", "", "", ""];
    arga.user_due_date_has_passed_array = [0, 0, 0, 0, 0];
    arga.user_grade_array = [0, 0, 0, 0, 0];
    arga.user_activity_scores = [0, 0, 0, 0, 0];
    arga.user_questions_received = [0, 0, 0, 0, 0];
    arga.user_target_score = lc.score.scoreTarget;

    // generate random data
    arga.participating_students = arga.user_id_array.length;
    arga.started_students = 0;
    arga.completed_students = 0;

    lc.courseAvgTime = lc.allTopics.reduce((a) => a + 11 + _.random(0, 2), 0)
    arga.user_time_on_task_array = _.shuffle([
        lc.courseAvgTime * 0.6 * 60,
        lc.courseAvgTime * 0.8 * 60,
        lc.courseAvgTime * 1.0 * 60,
        lc.courseAvgTime * 1.2 * 60,
        lc.courseAvgTime * 1.4 * 60,
    ])

    for (var i = 0; i < lc.allTopics.length; ++i) {
        var t = lc.allTopics[i];
        t.pa_arr = [];
        t.pe_arr = [];

        t.class_questions_received = 0;
        t.class_points_available = 0;
        t.class_points_earned = 0;

        var sum_scores = 0;
        var rb1 = (.85 + (Math.random() * .15)) * lc.score.scoreTarget / lc.allTopics.length;
        var rb2 = .4 + Math.random() * .35;
        for (var j = 0; j < arga.user_id_array.length; ++j) {
            t.pa_arr[j] =  Math.round(rb1 * (1 + Math.random()));
            t.pe_arr[j] = Math.round(t.pa_arr[j] * (rb2 + .25 * Math.random()));

            var question_count = Math.round(t.pe_arr[j] / 19);

            t.class_points_available += t.pa_arr[j];
            t.class_points_earned += t.pe_arr[j];

            sum_scores += (t.pe_arr[j] / t.pa_arr[j] * 100);
            arga.user_questions_received[j] += question_count;
            t.class_questions_received += question_count;
            arga.user_activity_scores[j] += t.pe_arr[j];
            if (arga.user_activity_scores[j] > lc.score.scoreTarget && arga.user_grade_array[j] == 0) {
                arga.user_grade_array[j] = 100;
                ++arga.completed_students;
            }
        }
        t.class_topic_score = Math.round(sum_scores / arga.participating_students);
    }

    _.each(arga.user_activity_scores, (score) => {
        score > 0 ? ++arga.started_students : null
    })

    /* this mirrors the logic found in function renderTopics in InstructorPage index.js
     * the following lines simply used to read "lc.topics = lc.allTopics", but with the topic exclusion
     * functionality and persisting that data even when viewing sample students, the topics and properties
     * and those in lc.allTopics need to mirror exactly
     */
    _.each(lc.allTopics, function (topic, index) {
      _.some(lc.topics, (activeTopic, activeTopicIndex) => {
          if (topic.label === activeTopic.label) {
            lc.topics[activeTopicIndex] = lc.allTopics[index]
          }
        })
    })

    // calculate class averages for questions received and activity scores
    arga.avg_activity_score = Math.round(calculateAverage(arga.user_rights_array, arga.user_activity_scores) * 10) / 10;
    arga.avg_questions_received = Math.round(calculateAverage(arga.user_rights_array, arga.user_questions_received) * 10) / 10;
    arga.topics = lc.topics

    return lc;
}

// unflatten arga student data
function formatArgaStudents(arga) {
    var students = []
    if (!arga || !arga.user_id_array) {
        return students
    }

    for (var i=0; i < arga.user_id_array.length; i++) {
        const tp = arga.topics.map((topic, idx, a) => {
            return {
                qr: _.round(arga.user_questions_received[i] / a.length),
                pe: topic.pe_arr[i],
                pa: topic.pa_arr[i],
                nl: topic.nextLevel
            }
        })

        const completedTimestamp = arga.user_activity_scores[i] > arga.user_target_score ?  moment.utc().subtract(_.random(1, 5 * 24, true), 'hours').toDate() : null
        const startedTimestamp = (completedTimestamp ? moment.utc(completedTimestamp) : moment.utc()).subtract(_.random(1, 5 * 24, true), 'hours').toDate()

        var stud = {
            index: i,
            id: arga.user_id_array[i],
            firstName: arga.user_firstName_array[i],
            lastName: arga.user_lastName_array[i],
            dueDate: arga.user_due_date_array[i],
            grade: arga.user_grade_array[i],
            score: arga.user_activity_scores[i],
            completion: arga.user_activity_scores[i],
            questionsReceived: arga.user_questions_received[i],
            startedTimestamp: startedTimestamp,
            completedTimestamp: completedTimestamp,
            timeOnTask: arga.user_time_on_task_array[i],
            activity_state: {
                qr: arga.user_questions_received[i],
                score: arga.user_activity_scores[i],
                target: arga.user_target_score,
                tp: tp,
                startQuizTime: 1527905053,
                completeQuizTime: 1527905109206,
                last_question_end: 1527905109207,
                total_question_time: 52435,
                total_questions_completed: arga.user_questions_received[i],
                hintCount: _.random(0,4),
                completedQuestionCount: Math.max(0, arga.user_questions_received[i] - _.random(0, 2)),
            }
        }
        students.push(stud)
    }

    return students;
}

function calculateAverage(user_rights_array, arr) {
    var l = arr.length;
    var sum = 0;
    var n = 0;
    for (var i = 0; i < l; ++i) {
        // skip non-students
        if (user_rights_array[i] > "1_student") {
            continue;
        }
        ++n;
        var val = arr[i] * 1;
        if (!isNaN(val) & val > 0) {
            sum += val;
        }
    }
    return sum / n;
}


export const simulateInstructorData = simulateData;
export const isInstructor = function () { return (Get_ARGA_Data('user_rights') === '3_instructor') };
export const isStudent = function () { return (Get_ARGA_Data('user_rights') === '1_student') };
export const getCourseId = function () { return Get_ARGA_Data('course_id') };
export const getLearnerId = function () { return Get_ARGA_Data('learner_id') };
